import React, { useEffect, useState } from 'react';
import ErrorBoundary from 'components/ErrorBoundary';
import { getUpdatedFilter, onExport } from 'utils/helper';
import useAxios from 'hooks/useAxios';
import AccumulationTables from './AccumulationTables';
import { cloneDeep } from 'lodash';


let initialFilters = {
  currentPage: 1,
  pageSize: 100,
  orderBy: '',
  order: '',
  filters: [],
  AccumulatorIDs: [],
};
const Accumulation = ({ tenantID, orgId ,rowData, AccountTypeID,recall }) => {
  console.log(rowData, "rowData");

  const API = useAxios();
  const [state, updateState] = useState({
    data: [],
    coveredEntity: [],
    loading: false,
    selectedEntity: '',
    coveredId: '',
    records: 0,
    reset: false,
  });

  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
  const [colFilter, setColFilter] = useState([]);
  //const [columnFilters, setColumnFilters] = useState([]);
  useEffect(() => {
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: '',
      order: '',
      filters: [],
      AccumulatorID: [],
    };
    setState({ data: [], records: 0 });
    if (AccountTypeID) {
      const { accumulatorID } = rowData;
      if (AccountTypeID) {
        initialFilters.filters = getUpdatedFilter(
          'AccountTypeID',
          AccountTypeID.toString(),
          initialFilters
        );
      }
      var acIds = [];
      acIds = accumulatorID;
      initialFilters.currentPage = 1;
      initialFilters.AccumulatorIDs = [acIds];
      initialFilters.order = 'desc';
      initialFilters.orderBy = 'ModifiedDate';

      fetchAccumulationData(initialFilters);
    }
  }, [AccountTypeID]);
  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };
  const fetchAccumulationData = async (pageDetails = {}, hasColumnFilter) => {
   debugger
    setState({ loading: true });
    let filter = { ...pageDetails };
    if (hasColumnFilter) {
      filter.filters = [...initialFilters.filters, ...pageDetails.filters];
      //initialFilters.filters = [...filter.filters];
    } else {
      initialFilters = { ...initialFilters, ...filter };
    }
    // let payload = {};
    // payload.AccumulatorID = pageDetails.AccumulatorID;
    // payload.Filters = pageDetails.filters;
    // payload.CurrentPage = pageDetails.currentPage
    // payload.PageSize = pageDetails.pageSize
    // payload.OrderBy = pageDetails.orderBy
    // payload.Order = pageDetails.order

    try {
      const { data } = await API.post(
        `SBTenant/${tenantID}/Inventory/Accumulations/${rowData.ndc}`, filter,
        {
          hasDefaultURL: true,
          hideLoder: true,
        });
      if (data?.items?.length > 0) {
        setState({
          data: data.items,
          records: data.totalRecords,
          loading: false,
        });
        recall(data.items)

      } else {
        setState({
          data: [],
          records: 0,
          loading: false,
        });
      }
    } catch (error) {
      console.error('API Error:', error);
      setState({ loading: false, data: [], records: 0 });
    }
  };

  const handleExport = async () => {
    debugger;
    const filterObj = cloneDeep(initialFilters);
    if (colFilter?.filters?.length > 0) {
      filterObj.filters = [...filterObj.filters, ...colFilter.filters];
    }

    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};

      var additionalCriteria = {};
      additionalCriteria.IsSelectedColumn = false;
      additionalCriteria.OrgId = orgId.organizationID;
       // additionalCriteria.ContractId = 0;
    // additionalCriteria.POId = parseInt(rowData.ndc);
     additionalCriteria.OpaId = rowData.ndc;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;

    var payload = {};
    payload.tenantID = tenantID
    payload.gridCode = "accumulations1";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
  //  onExport(action, initialFilters);
  };

  const handleSearchColumnFilters = async (columnFilters) => {
    debugger
    initialFilters.currentPage = 1;
    setColFilter(columnFilters);
    await fetchAccumulationData({ ...initialFilters, ...columnFilters }, true);
  };

  const onPageChange = (filter, hasFilter) => {
    updateInitialFilterSearch(filter);
    if (hasFilter) {
      fetchAccumulationData(filter, true);
    } else {
      fetchAccumulationData(filter);
    }
  };

 const updateInitialFilterSearch = (filter) => {
     initialFilters.currentPage = filter.currentPage;
      initialFilters.pageSize = filter.pageSize;
       initialFilters.order = filter.order;
        initialFilters.orderBy = filter.orderBy;
  }

  const refetch = (hasReset) => {
    debugger
    if (hasReset) {
      setColFilter([]);
      initialFilters = {
        ...initialFilters,
      //  filters:[],
        currentPage: 1
      };
    }
    fetchAccumulationData(initialFilters);
  };
  return (
    <div>
      <ErrorBoundary>
        <AccumulationTables
        onPageSizeChange={onPageSizeChange}
          data={state.data}
          loading={state.loading}
          onExport={handleExport}
          totalSize={state.records}
          filters={initialFilters}
          onPageChange={onPageChange}
          setLoading={(value) => setState({ loading: value })}
          onSearchColumnFilters={handleSearchColumnFilters}
          refetch={refetch}
        />
      </ErrorBoundary>

    </div>

  );
};

export default Accumulation;
